if (!customElements.get('product-media')) {
  class ProductMedia extends HTMLElement {
    selectors = {
      swiper: '.swiper',
      scrollbar: '.swiper-scrollbar',
    };

    settings = {
      slidesPerView: 1,
      spaceBetween: 16,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 1.354,
        },
      },
    };

    slider = undefined;
    breakpoint = window.matchMedia('(max-width: 989px)');

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();

      // Re-init on viewport changes
      this.breakpoint.addEventListener('change', (event) => {
        this.handleBreakpoint(event);
      });
    }

    init() {
      const swiper = this.querySelector(this.selectors.swiper);
      if (!swiper) return;

      if (!this.breakpoint.matches) {
        this.destroy();
        return;
      }

      this.slider = new Swiper(swiper, this.settings);
    }

    destroy() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = undefined;
      }
    }

    handleBreakpoint(event) {
      this.init();
    }
  }

  customElements.define('product-media', ProductMedia);
}
